import {useContext} from 'react'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {MultiSiteContext} from '@salesforce/retail-react-app/app/contexts'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import BrandContext from '../contexts/brand-context'
import {resolvePublicOrigin} from '../utils/site-config'

/*
 * On the server APP_ORIGIN is the bare MRT hostname, which bypasses the CDN and is
 * rejected (403) when MRT access control is on. Loop back through the brand's public,
 * CDN-fronted domain (PWA_DOMAIN_SITE_MULTI) so the CDN re-adds x-sfdc-access-control.
 */
export const getSsrFetchOrigin = ({appOrigin, appConfig, siteId, brandId}) => {
    if (typeof window !== 'undefined') return appOrigin
    // Dev-only: the public-domain pref always names a deployed host, so a local
    // SSR would otherwise fetch its own endpoints from remote (old) code.
    if (process.env.SSR_LOOPBACK_ORIGIN) return process.env.SSR_LOOPBACK_ORIGIN
    return resolvePublicOrigin(appConfig, siteId, brandId) || appOrigin
}

// Origin for requests the app makes to its own endpoints (/api/*-ssr, /optimizely-page,
// /seo-homepage, /mobify/proxy/*). Client: page origin. Server: see getSsrFetchOrigin.
export const useSsrFetchOrigin = () => {
    const appOrigin = useAppOrigin()
    const siteId = useContext(MultiSiteContext)?.site?.id
    const brandId = useContext(BrandContext)?.brandId
    const {app: appConfig} = getConfig() || {}
    return getSsrFetchOrigin({appOrigin, appConfig, siteId, brandId})
}
